import React from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';

const LinkedInCredentialsForm = ({ formik, isRestricted, eventId }) => {
    return (
        <>
            <div className="linkedin-note-banner">
                <strong>Note:</strong> Text and Banner Image for Sharing on LinkedIn can be configured under{" "}
                <Link to={`/e/${eventId}/eventInfo/tickets/settings`} className="ticket-settings-link">
                    Ticket Settings
                </Link>
                .
            </div>
            <div className="linkedin-credentials flex-column p-3 mt-3">
                <div className="linkedin-instructions-title">Application Credentials</div>
                <p>Provide the following credentials to enable LinkedIn sharing on your behalf.</p>
                <div className="d-flex" style={{ gap: "15px" }}>
                    <div className="linkedin-credentials-field">
                        <label htmlFor="linkedin_client_id">Client ID&nbsp;<span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className={
                                formik.touched.linkedin_client_secret && formik.errors.linkedin_client_id
                                    ? "input border-danger px-2 "
                                    : "input px-2 "
                            }
                            id="linkedin_client_id"
                            name="linkedin_client_id"
                            placeholder="Enter Client ID"
                            {...formik.getFieldProps("linkedin_client_id")}
                            disabled={isRestricted}
                        />
                        {formik.touched.linkedin_client_id && formik.errors.linkedin_client_id && (
                            <p className="custom-error-input-class text-danger pt-1">
                                {formik.errors.linkedin_client_id}
                            </p>
                        )}
                    </div>
                    <div className="linkedin-credentials-field">
                        <label htmlFor="linkedin_client_secret">Primary Client Secret&nbsp;<span className="text-danger">*</span></label>
                        <input
                            type="text" className={
                                formik.touched.linkedin_client_secret && formik.errors.linkedin_client_secret
                                    ? "input border-danger px-2 "
                                    : "input px-2 "
                            }
                            id="linkedin_client_secret"
                            name="linkedin_client_secret"
                            placeholder="Enter Client Secret"
                            {...formik.getFieldProps("linkedin_client_secret")}
                            disabled={isRestricted}
                        />
                        {formik.touched.linkedin_client_secret && formik.errors.linkedin_client_secret && (
                            <p className="custom-error-input-class text-danger pt-1">
                                {formik.errors.linkedin_client_secret}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

LinkedInCredentialsForm.propTypes = {
    formik: PropTypes.object.isRequired,
    isRestricted: PropTypes.bool
};

export default LinkedInCredentialsForm;
